import React, { useRef } from 'react'
import styles from './index.module.less'
import { Popover, App } from 'antd'
import headAvatar from '../img/head_white.svg'
import { useTranslation } from 'react-i18next'
import { logout } from '@/api/user'
import { useNavigate } from 'react-router-dom'
import ChangePwd from './changePwd'

const Personal = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { modal } = App.useApp()
  const changePwdRef = useRef<any>(null)

  const onLogout = async () => {
    modal.confirm({
      title: t('ikg.warn'),
      content: t('ikg.logoutConfirm'),
      centered: true,
      onOk: async () => {
        await logout()
        localStorage.removeItem('token')
        navigate('/login')
      },
      transitionName: 'custom-slide-up',
    })
  }
  const renderContent = () => {
    return (
      <>
        {/* <div className={styles.setting}>账号设置</div> */}
        <div
          className={styles.setting}
          onClick={() => {
            changePwdRef.current.open()
          }}
        >
          {t('ikg.changePwd')}
        </div>
        <div className={styles.setting} onClick={onLogout}>
          {t('ikg.logout')}
        </div>
      </>
    )
  }
  return (
    <>
      <div className={styles.defaultHeader}>
        <Popover placement="bottom" content={renderContent()} trigger="click">
          <img src={headAvatar} style={{ cursor: 'pointer' }} />
        </Popover>
      </div>
      <ChangePwd ref={changePwdRef} />
    </>
  )
}

export default Personal
